














































































































































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import { required } from 'vuelidate/lib/validators';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';

const cssPrefix = 'sesModal';
@Component({
  components: {
    ...UUIFComponent,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwTextfield,
    SwSelect,
    SwIconButton,
  },
  validations: {
    selectedDatacenter: { required },
    friendlyName: { required },
  },
})
export default class SESModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  isModalOpen: boolean;
  @Prop()
  taskListId: string;
  dcOptions: any[] = [];
  selectedDatacenter: string = '';
  friendlyName: string = '';
  showAll: boolean = false;
  screen: string = 'first';

  get sesData() {
    return this.$store.getters['MswProductsStoreModule/getSESData'];
  }

  get visibleItems() {
    return this.showAll
      ? this.sesData?.sesListEligibleFirewall
      : this.sesData.sesListEligibleFirewall.slice(0, 3);
  }

  get scrollStyle() {
    return {
      maxHeight: '60px',
      overflowY: 'auto',
      marginBottom: '10px',
    };
  }

  get features() {
    return [
      {
        icon: require('@/assets/images/file.svg'),
        title: this.$t('products.sesModal.featureTitle1'),
        description: this.$t('products.sesModal.featureTxt1'),
      },
      {
        icon: require('@/assets/images/web.svg'),
        title: this.$t('products.sesModal.featureTitle2'),
        description: this.$t('products.sesModal.featureTxt2'),
      },
      {
        icon: require('@/assets/images/bug.svg'),
        title: this.$t('products.sesModal.featureTitle3'),
        description: this.$t('products.sesModal.featureTxt3'),
      },
      {
        icon: require('@/assets/images/shield.svg'),
        title: this.$t('products.sesModal.featureTitle4'),
        description: this.$t('products.sesModal.featureTxt4'),
      },
    ];
  }

  activateOrProceed() {
    if (this.sesData.casDataCenter) {
      this.dcOptions = this.sesData.casDataCenter.map((each: any) => {
        return {
          id: each.dataCenterId,
          label: each.dataCenterName,
          value: each.dataCenterId,
        };
      });
      this.screen = 'second';
    } else {
      this.activateSESPromo();
    }
  }

  validateForm() {
    this.$v!.friendlyName!.$touch();
    this.$v!.selectedDatacenter!.$touch();
    if (!this.$v!.friendlyName!.$invalid && !this.$v!.selectedDatacenter!.$invalid) {
      this.activateSESPromo();
    }
  }

  activateSESPromo() {
    const request: {
      customerTaskId: string;
      sesTenantSerialNumber: string;
      registerses: 'YES' | 'NO';
      sesLicQuantity: string;
      sesExpirationDate: string;
      taskName: string;
      casbsubdomain?: string;
      casbDataCenter?: string;
    } = {
      customerTaskId: this.taskListId || '',
      sesTenantSerialNumber: this.sesData?.sesTenantSerialNumber || '',
      registerses: this.sesData?.registerses || '',
      sesLicQuantity: this.sesData?.sesLicQuantity || '',
      sesExpirationDate: this.sesData?.sesExpirationDate || '',
      taskName: 'ACTIVATESESPROMO',
    };
    if (this.friendlyName !== '') {
      request.casbsubdomain = this.friendlyName;
    }
    if (this.selectedDatacenter !== '') {
      request.casbDataCenter = this.selectedDatacenter;
    }
    this.$store
      .dispatch('MswProductsStoreModule/completeTodoList', request)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', {
            infoType: 'success',
            infoMsg: res.msgDesc,
          });
          this.$emit('update-todo');
          this.closeDialog();
        } else {
          this.$store.commit('enqueueMessage', {
            infoType: 'failed',
            infoMsg: res.msgDesc,
          });
        }
      });
  }

  closeDialog() {
    this.$emit('close-dialog');
    this.screen = 'first';
  }

  navigateToNavattic() {
    window.open('https://sonicwall.navattic.com/k3a0vev', '_blank');
  }
}
